import { BaseFilterInput } from "../../../common-models/BaseFilterInput";

export class FilterCustomerInput extends BaseFilterInput {
    document?: string;
    name?: string;
    email?: string;
    phone?: string;
    creationStartDate?: any;
    creationEndDate?: any;
    lastModificationStartDate?: any;
    lastModificationEndDate?: any;
}